'use client';
import React from 'react';
import { BzImage } from '@benzinga/image';
import { aboutAPIPills } from '../mock';
import styled from '@benzinga/themetron';
import { Button } from '@benzinga/core-ui';
import { SmartLink } from '@benzinga/analytics';
import { FusionSection, FusionSectionContent, FusionSectionText, FusionSectionTitle } from '@benzinga/ui';

const AboutAPIs = () => {
  return (
    <StyledSection>
      <FusionSectionContent paddingHorizontal={false}>
        <BzImage
          height="40px"
          src={'https://www.benzinga.com/apis/wp-content/themes/enduz/images/logo-new.png?new'}
          width={'168px'}
        />
        <StyledSectionTitle>
          INSTITUTIONAL GRADE MARKET
          <div>NEWS & DATA APIS</div>
        </StyledSectionTitle>
        <FusionSectionText>The Largest News Vendor to North American Brokerages</FusionSectionText>
        <PillsWrapper>
          {aboutAPIPills.map((title, i) => (
            <AboutAPIPill key={i} title={title} />
          ))}
        </PillsWrapper>
        <SmartLink href="/apis/" target="_self">
          <StyledButton size="lg" variant="flat-blue">
            {"LET'S GET STARTED"}
          </StyledButton>
        </SmartLink>
      </FusionSectionContent>
    </StyledSection>
  );
};

interface AboutAPIPillProps {
  title: string;
}

const AboutAPIPill = ({ title }: AboutAPIPillProps) => {
  return <PillWrapper>{title}</PillWrapper>;
};

const PillWrapper = styled.div`
  //background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(6px);
  border-radius: 4px;
  color: ${({ theme }) => theme.colorPalette.gray100};
  padding: 8px 16px;
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  font-size: ${({ theme }) => theme.fontSize.base};
  line-height: ${({ theme }) => theme.lineHeight[5]};

  @media screen and (max-width: 767px) {
    width: 100%;
    text-align: center;
  }
`;

const StyledSection = styled(FusionSection)`
  background-image: url('/next-assets/images/about/apis-bg-image.jpg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  padding-top: 24px;
  padding-bottom: 24px;
`;

const StyledSectionTitle = styled(FusionSectionTitle)`
  margin-top: 40px;
  color: ${({ theme }) => theme.colorPalette.white} !important;
`;

const PillsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 48px;
  margin-top: 24px;

  @media screen and (max-width: 959px) {
    margin-bottom: 24px;
  }

  @media screen and (max-width: 767px) {
    margin-bottom: 16px;
  }
`;

const StyledButton = styled(Button)`
  @media screen and (max-width: 767px) {
    width: 100%;
  }
`;

export default AboutAPIs;
